import { useEffect, useState } from 'react';
import { useGeocoder } from '../../services/GeocoderGoogleMaps';
import { getSearchConfigurations } from './helpers';
/**
 * Call google api with location Form fields string
 * to get GEO data and show map preview
 */
export const useLocationPredictions = ({ form, locationUnits }) => {
    const geocoder = useGeocoder();

    const [predictionInProgress, setPredictionInProgress] = useState(false);
    const [predictionSelected, setPredictionSelected] = useState(null);
    const [predictionError, setPredictionError] = useState(null);

    const { getFieldState } = form;

    const predictLocation = async () => {
        if (!locationUnits || predictionInProgress) {
            return;
        }
        setPredictionInProgress(true);

        if (form) {
            /** may be used to notify form on request being made */
            form.change('location', undefined);
        }

        try {
            const { value } = getFieldState('country') || {};

            const predictionData = await geocoder.getPlaceDetailsFromString({
                locationUnitsStr: locationUnits,
                /** predict locations related to selected country only */
                searchConfigurationsProp: {
                    types: ['geocode'],
                    ...getSearchConfigurations(value),
                },
            });

            if (!predictionData || !predictionData.origin) {
                throw new Error(
                    'Adresse konnte nicht gefunden werden. Bitte kontaktiere unseren Support.'
                );
            }

            if (form) {
                form.change('location', predictionData.origin);
            }
            setPredictionSelected(predictionData);
            setPredictionInProgress(false);
        } catch (e) {
            setPredictionInProgress(false);
            setPredictionError(e.message || 'Failed to get location info.');
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            predictLocation(locationUnits);
        }, 350);

        return () => clearTimeout(timer);
    }, [locationUnits]);

    return { predictionInProgress, predictionSelected, error: predictionError };
};
